@if (
  {
    row: columnData | async,
  };
  as $
) {
  <p>{{ regularStatus[$.row!.clt_is_irregular] }}</p>
}
